export const userProfileSettingsTour = {
  key: "userProfileSettings",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="profile-sidebar"]',
      content: t("Tour_UserProfileSettings_Sidebar"),
      placement: "right",
      disableBeacon: true,
    },
    {
      target: '[data-tour="profile-general"]',
      content: t("Tour_UserProfileSettings_General"),
      placement: "bottom",
    },
    {
      target: '[data-tour="profile-experience"]',
      content: t("Tour_UserProfileSettings_Experience"),
      placement: "bottom",
    },
    {
      target: '[data-tour="profile-services"]',
      content: t("Tour_UserProfileSettings_Services"),
      placement: "bottom",
    },
    {
      target: '[data-tour="profile-skills"]',
      content: t("Tour_UserProfileSettings_Skills"),
      placement: "bottom",
    },
    {
      target: '[data-tour="profile-availability"]',
      content: t("Tour_UserProfileSettings_Availability"),
      placement: "bottom",
    },
    {
      target: '[data-tour="profile-posts"]',
      content: t("Tour_UserProfileSettings_Posts"),
      placement: "bottom",
    },
    {
      target: '[data-tour="profile-paymentCard"]',
      content: t("Tour_UserProfileSettings_Payment"),
      placement: "bottom",
    },
    {
      target: '[data-tour="profile-account"]',
      content: t("Tour_UserProfileSettings_Account"),
      placement: "bottom",
    },
  ],
};
